export default "__VITE_ASSET__4724bef1__"